import request from './request.js'
import Vue from 'vue'
import apiConfig from './apis'

const createRequest = request(apiConfig)

if (!Vue.prototype.$api) Vue.prototype.$api = createRequest

export default createRequest



// WEBPACK FOOTER //
// ./src/api/index.js